const KEYS = ["src", "utm_source", "utm_medium", "utm_campaign"];

export const captureParams = () => {
  const p = new URLSearchParams(window.location.search);
  KEYS.forEach((k) => {
    const v = p.get(k);
    if (v) sessionStorage.setItem(`wc_${k}`, v);
  });
};

export const getTracking = () => ({
  source: sessionStorage.getItem("wc_src") || "direct",
  utm_source: sessionStorage.getItem("wc_utm_source") || "",
  utm_medium: sessionStorage.getItem("wc_utm_medium") || "",
  utm_campaign: sessionStorage.getItem("wc_utm_campaign") || "",
  page: window.location.href,
});

export const trackLead = () => {
  if (window.fbq) window.fbq("track", "Lead");
};

export const trackSummitInterest = () => {
  if (window.fbq) window.fbq("trackCustom", "SummitInterest");
};
